export default {
  namespaced: true,
  state: {
    session: null,
    department: null
  },

  getters: {
    session: state => state.session
  },

  mutations: {
    SET_SESSION: (state, payload = null) => {
      if ((payload.user != null) && (!payload.user.gender)) {
        payload.user.gender = {
          id: null,
          title: null
        }
      }

      state.session = payload
    },
    USER_UPDATE: (state, payload = null) => {
      state.session.user = payload
    },
    SET_DEPARTMENT: (state, payload = null) => {
      state.department = payload
    },
    FIKE_SESSION: (state) => {
      state.session = { id: 49, stage: 20, user: { id: 28, age: 21, name: 'Иван', phone: '79324818698', gender: { id: 1, title: null }, email: 'test@we.er' } }
    },
    CLEAR_SESSION: (state) => {
      state.session = null
    }
  },

  actions: {
    SEND_CODE: async function ({ commit }, payload) {
      const { data } = await this.$api.session.sendCode(payload)
      commit('SET_SESSION', data)
    },
    OPEN: async function ({ commit }, payload) {
      const { data } = await this.$api.session.open(this.state.session.session.id, payload)
      commit('SET_SESSION', data)
    },
    CLOSE: async function ({ commit }, payload) {
      await this.$api.session.close(this.state.session.session.id, payload)
      commit('CLEAR_SESSION')
    },
    EDIT_DEPARTMENT: ({ commit }, payload) => {
      commit('SET_DEPARTMENT', payload)
    },
    DEMO: function ({ commit }, payload) {
      const data = payload
      if (!data.user.gender) {
        data.user.gender = {
          id: 999,
          title: '-'
        }
      }

      commit('SET_SESSION', data)
    }

  }
}
